import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { classiPerCriterio, COLORE_CLASSE_ASSENTE, coloreClasse, IndiceRischio } from '../../../../../models/rischio-analitico.model';

@Component({
  selector: 'ebw-monorepo-rischio-analitico-legenda-dialog',
  templateUrl: './rischio-analitico-legenda-dialog.component.html',
  styleUrls: ['./rischio-analitico-legenda-dialog.component.scss']
})
export class RischioAnaliticoLegendaDialogComponent {
  voci: { classe: string; colore: string }[];
  titolo: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { criterio: IndiceRischio }) {
    this.voci = [
      ...classiPerCriterio(data.criterio).map((classe) => ({ classe, colore: coloreClasse(classe, data.criterio) })),
      { classe: 'Classe non calcolata', colore: COLORE_CLASSE_ASSENTE }
    ];
    this.titolo = data.criterio === 'integrated' ? 'Criticità' : 'Classi di rischio';
  }
}
